import AssetList from "../../slices/assets/asset/AssetList";
import AssetDetails from "../../slices/assets/asset/AssetDetails";
import AssetByCategory from "../../slices/assets/asset/AssetByCategory";
import AssetIssueByItem from "../../slices/assets/asset_issue/AssetIssueByItem";
import AssetIssueList from "../../slices/assets/asset_issue/AssetIssueList";
import AssetIssueDetails from "../../slices/assets/asset_issue/AssetIssueDetails";
import AssetNotes from "../../slices/assets/assets_location/AssetNotesList";
import MaintenanceByAssetDetails from "../../slices/assets/assets_location/MaintenanceByAssetDetails";
import InstructionDetails from "../../slices/assets/modal/InstructionList";
import AssetDetailsByFilter from "../../slices/assets/inventory/AssetDetailsByFilter";
import UpdateAssetSerialNumbers from "../../slices/assets/inventory/UpdateAssetSerialNumbers";
import GrnStockList from "../../slices/grn/stock/GrnStockList";
import StockDetails from "../../slices/grn/stock/StockDetails";
import InstructionList from "../../slices/assets/modal/InstructionList";
import GrnList from "../../slices/assets/asset/GRNList";
import GrnDetails from "../../slices/assets/asset/GRNDetails";
import AmcList from "../../slices/assets/amc/AmcList";
import AmcDetails from "../../slices/assets/amc/AmcDetails";

const assetReducer = {
    assetList: AssetList,
    assetDetails: AssetDetails,
    assetByCategory: AssetByCategory,
    assetIssueByItem: AssetIssueByItem,
    assetIssueList: AssetIssueList,
    assetIssueDetails: AssetIssueDetails,
    assetNotes: AssetNotes,
    maintenanceByAssetDetails: MaintenanceByAssetDetails,
    instructionDetails: InstructionDetails,
    assetDetailsByFilter: AssetDetailsByFilter,
    updateAssetSerialNumbers: UpdateAssetSerialNumbers,
    grnStockList: GrnStockList,
    stockDetails: StockDetails,
    instructionList: InstructionList,
    grnList: GrnList,
    grnDetails: GrnDetails,
    amcList: AmcList,
    amcDetails: AmcDetails,
};

export default assetReducer;